import React from 'react';
import TickBox from './TickBox';

// Collection and playlist card: a cover that opens the drawer, then its own
// tick row. Tapping the cover never selects.
const PhotoTile = ({
  name,
  cover,
  checked,
  atLimit,
  locked,
  onOpen,
  onToggle,
  showView
}) => {
  const capped = !checked && atLimit;
  // No cover means a name-only face. Nothing is generated to fill the gap.
  const faced = !!cover;
  return React.createElement("div", {
    className: `cp-tile${checked ? ' is-on' : ''}${locked && !checked ? ' is-locked' : ''}`
  }, React.createElement("button", {
    type: "button",
    className: `cp-tile-photo${faced ? '' : ' is-blank'}`,
    style: faced ? {
      backgroundImage: `url(${cover})`
    } : undefined,
    onClick: onOpen,
    "aria-label": `Open ${name}`
  }, faced && React.createElement("span", {
    className: "cp-tile-scrim"
  }), React.createElement("span", {
    className: "cp-tile-name"
  }, name), showView && React.createElement("span", {
    className: "cp-tile-view"
  }, "View")), React.createElement("button", {
    type: "button",
    className: `cp-tickrow${checked ? ' is-on' : ''}${capped ? ' is-capped' : ''}`,
    onClick: onToggle,
    "aria-label": `${checked ? 'Deselect' : 'Select'} ${name}`
  }, React.createElement(TickBox, {
    checked: checked
  }), React.createElement("span", null, checked ? 'Selected' : capped ? 'Limit reached' : 'Select')));
};
export default PhotoTile;
